import * as _ from "lodash";
import { RSAKeyPairOptions } from "crypto";

let apps = (state = [], action) => {
  let index = -1
  let name = "APP"
  switch (action.type) {
    case `FETCH_${name}`:
      state = action.payload
      break;
    case `ADD_${name}`:
    case `GET_${name}`:
      state = state.concat([action.payload])
      break;
    case `UNSHIFT_${name}`:
      state.unshift(action.payload)
      break;
    case `DELETE_${name}`:
      index = _.findIndex(
        state, item => item._id == action.payload
      )
      if (index !== -1) {
        state.splice(index, 1)
      }
      break;
    case `EDIT_${name}`:
      index = _.findIndex(
        state, item => item._id == action.payload._id
      )
      console.log("index: ", index)
      if (index !== -1) {
        state[index] = action.payload
      }
      console.log("state: ", state)
      break;
  }
  return state;
};


export default apps


// WEBPACK FOOTER //
// ./src/reducer/app.js